import { FC } from 'react';
import { formatWithLocale } from 'shared/lib/date';
import styles from './styles.module.scss';
import clsx from 'clsx';
import { ITimeslot } from 'entities/timeslots/store/types';

interface TimeslotProps {
	slot: ITimeslot;
	selectedSlot: ITimeslot | null;
	selectSlot: (timeslot: ITimeslot) => void;
}

export const Timeslot: FC<TimeslotProps> = ({
	slot,
	selectedSlot,
	selectSlot,
}) => {
	// useEffect(() => {
	// 	console.log({...selectedSlot})
	// }, [selectedSlot])

	const timeslotItemClass = clsx(styles['timeslots__slot'], {
		[styles['timeslots__slot--active']]: slot.id === selectedSlot?.id,
		[styles['timeslots__slot--deactive']]: slot.id !== selectedSlot?.id,
	});

	return (
		<div
			key={slot.id}
			className={timeslotItemClass}
			onClick={() => {
				selectSlot(slot);
			}}
		>
			{formatWithLocale(slot.start, 'HH:mm')}
		</div>
	);
};
